import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MdDialogModule} from '@angular/material';
import {RouterModule} from '@angular/router';
import {BookingHeaderComponent} from './booking-header.component';

@NgModule({
  imports: [CommonModule, RouterModule, MdDialogModule],
  declarations: [BookingHeaderComponent],
  exports: [BookingHeaderComponent],
})
export class BookingHeaderModule {}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-header/booking-header.module.ts